module.exports = __webpack_public_path__ + "img/activity2_img2.3c5b82c2.png";